import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import Counter from '../../../counter';

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        background-color: ${theme.colors['surface-white']};
        border-radius: 4px;
        box-shadow: ${theme.shadows['shadow-02dp']};
        height: 96px;
        padding: 8px;
        width: 180px;

        position: absolute;
    `}
`;

const MatrixPopover = ({ deleteMatrix, printMatrix }) => {
    const [rows, setRows] = useState(2);
    const [columns, setColumns] = useState(2);

    useEffect(() => {
        deleteMatrix();

        let mathml = '<math xmlns="http://www.w3.org/1998/Math/MathML"><mfenced open="|" close="|"><mtable>';
        let row = '<mtr>'.concat('<mtd/>'.repeat(columns)).concat('</mtr>');
        mathml = mathml.concat(row.repeat(rows)).concat('</mtable></mfenced></math>');
        printMatrix(mathml);
    }, [rows, columns, deleteMatrix, printMatrix]);

    return (
        <Container>
            <Counter label="Righe" min={1} onChange={setRows} value={rows} />
            <Counter label="Colonne" min={1} onChange={setColumns} value={columns} />
        </Container>
    );
};

MatrixPopover.propTypes = {
    deleteMatrix: PropTypes.func,
    printMatrix: PropTypes.func,
};

export default MatrixPopover;
